import React from 'react';
import { Grid, Typography } from "@material-ui/core";

export const MemberName = ({name}) => (
  <Grid container>
    <Grid item xs={12}>
      <Typography variant={"h6"}>{name}</Typography>
    </Grid>
  </Grid>
)
